import DashboardIcon from "@mui/icons-material/Dashboard"
import GroupIcon from "@mui/icons-material/Group"
import InsertChartIcon from "@mui/icons-material/InsertChart"
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore"
import LocalShippingIcon from "@mui/icons-material/LocalShipping"
import LogoutIcon from "@mui/icons-material/Logout"
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts"
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive"
import PsychologyIcon from "@mui/icons-material/Psychology"
import SettingsIcon from "@mui/icons-material/Settings"
import SettingsSystemDaydreamIcon from "@mui/icons-material/SettingsSystemDaydream"
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag"
import React, { useContext } from "react"
import { Link } from "react-router-dom"
import { DarkModeContext } from "../../context/darkModeContext"
import "./sidebar.scss"

export const Sidebar = () => {
  const { dispatch } = useContext(DarkModeContext)

  return (
    <div className="sidebar">
      <div className="top">
        <Link to={"/"}>
          <span className="logo">Laradmin</span>
        </Link>
      </div>
      <hr />
      <div className="center">
        <ul>
          <p className="title">MAIN</p>
          <Link to={"/"}>
            <li>
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </li>
          </Link>
          <p className="title">LISTS</p>
          <Link to={"/users"}>
            <li>
              <GroupIcon className="icon" />
              <span>Users</span>
            </li>
          </Link>
          <Link to={"/products"}>
            <li>
              <ShoppingBagIcon className="icon" />
              <span>Products</span>
            </li>
          </Link>
          <Link to={"/orders"}>
            <li>
              <LocalGroceryStoreIcon className="icon" />
              <span>Orders</span>
            </li>
          </Link>
          <Link to={"/deliveries"}>
            <li>
              <LocalShippingIcon className="icon" />
              <span>Deliveries</span>
            </li>
          </Link>
          <p className="title">USEFULL</p>
          <Link to={"/statistics"}>
            <li>
              <InsertChartIcon className="icon" />
              <span>Statistics</span>
            </li>
          </Link>{" "}
          <Link to={"/notfications"}>
            <li>
              <NotificationsActiveIcon className="icon" />
              <span>Notifications</span>
            </li>
          </Link>
          <p className="title">SERVICE</p>
          <li>
            <SettingsSystemDaydreamIcon className="icon" />
            <span>System</span>
          </li>
          <li>
            <PsychologyIcon className="icon" />
            <span>Logs</span>
          </li>
          <li>
            <SettingsIcon className="icon" />
            <span>Settings</span>
          </li>
          <p className="title">USER</p>
          <li>
            <ManageAccountsIcon className="icon" />
            <span>Profile</span>
          </li>
          <li>
            <LogoutIcon className="icon" />
            <span>Logout</span>
          </li>
        </ul>
      </div>
      <div className="bottom">
        <div
          className="colorOptions"
          onClick={() => dispatch({ type: "LIGHT" })}
        ></div>
        {/* <div className="colorOptions"></div> */}
        {/* <div className="colorOptions"></div> */}
        <div
          className="colorOptions"
          onClick={() => dispatch({ type: "DARK" })}
        ></div>
      </div>
    </div>
  )
}
